import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Col, Button} from 'reactstrap';

//import './html/fontawesome/css/all.min.css';
import { MagstimColor } from "./../Magstim.Color";
import { CurrentTheme } from "common";
import { magstim_eventHandler } from "./magstim";


class MagstimAccordion extends React.Component {


    constructor() {
        super();

        this.state = {
            isOpen: false
        };
    }

    handleClick(value) {
        magstim_eventHandler("click", value);
    }

    toggleOnClick = (event) => {
        // set internal state of accordion/chevron
        let openState = !this.state.isOpen;
        this.setState({
			isOpen: openState
        });
        
        if(this.props.toggleOnClick){
            this.props.toggleOnClick(this.props.eventKey);
        }
    }

    render() {

        var wrapperStyle = {
            padding: '5px 5px 5px 10px',
            font_weight: '10'
        };

        if(this.props.smallLayout === true){
            wrapperStyle ={
                padding: '4px 0px 0px 0px',
                font_weight: '500'
            };
       }

        return (
            <Wrapper className="row" wrapperStyle={wrapperStyle}>
                <Col xs={8}>
                    <h3>{this.props.title}</h3>
                </Col>
                <Col xs={4} className="align-right">
                    <Button size={CurrentTheme().ControlSize} color="secondary" onClick={this.toggleOnClick} className="float-right mt-2">
                        {!this.state.isOpen && <i className="fas fa-chevron-down"></i>}
                        {this.state.isOpen && <i className="fas fa-chevron-up"></i>}
                    </Button>
                </Col>
            </Wrapper>
        );
    }
}

MagstimAccordion.propTypes = {
    title: PropTypes.string,
    main_icon: PropTypes.string,
    eventKey: PropTypes.string,
    smallLayout: PropTypes.bool
};

MagstimAccordion.defaultProps = {
    title: '',
    main_icon: '',
    eventKey: '',
    smallLayout:false
};

const Wrapper = styled.div`

    padding: 5px;
    color: ${ MagstimColor.MagstimWhite};
    background-color: ${ MagstimColor.MagstimTextBackground};
    border: none;
    vertical-align: middle;

    h3 {
        margin: 0;
        padding: ${props => props.wrapperStyle.padding};
        font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        font-size: ${ CurrentTheme().MagstimNavBarFontSizeSmall };
        font-weight:  ${props => props.wrapperStyle.font_weight};
        vertical-align: middle;
        line-height: 40px;
    }
`;

export default MagstimAccordion;